// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title1[data-v-dd157e30] {\n  font-size: 25px;\n  font-weight: 600;\n  line-height: 1.25;\n  color: #3c4858;\n}\n.text1[data-v-dd157e30] {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.25;\n  color: #3c4858;\n}\n", ""]);
// Exports
module.exports = exports;
